import ExternalLink from '../../components/ExternalLink'
import { Page } from '../types'

const render = () => {
    return <>
        <p>Welcome to the Gurobi Installation Navigator! This tool gives you personalized instructions for installing Gurobi based on
           the architecture of your choice.
        </p>
        <ul>
            <li>The sidebar on the left allows you to describe this architecture. If you have received a link
                to this tool from your Technical Account Manager, it typically pre-fills these choices for you.</li>
            <li>The diagram at the top shows you the various software components involved.</li>
            <li>On the right you will see a table of contents; for each software component there are
                one or more pages describing the steps required to configure that component.</li>
        </ul>
        
        <h3 className="text-info">This tool is a work in progress.</h3>
        <p>
            If you encounter any problems while getting started with Gurobi, please get in touch
            with your Technical Account Manager or raise a <ExternalLink href='https://support.gurobi.com/'>support ticket</ExternalLink>.
            You may find additional information in our generic <ExternalLink href='https://support.gurobi.com/hc/en-us/articles/14799677517585-Getting-Started-with-Gurobi-Optimizer'>
            Getting Started guides</ExternalLink>. Finally: Feedback on this tool and ideas to improve it further are welcome!
        </p>
    </>
}


const Introduction : Page<{}> = { key: 'intro', title: 'About this tool', render }

export default Introduction